import Vue from 'vue';
import routes from '@/router/routes';
import VueRouter from 'vue-router';
import { isUUID } from '@/utils/isUUID';
import {
  destroyAllTooltips,
  destroyAllModals,
  destroyOpenFilters,
} from '@inscribe/signal';

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  // close all existing elements in page
  destroyAllTooltips();
  destroyAllModals();
  destroyOpenFilters();

  // Prevent anything but a number being inserted in place of IDs in URL
  const areAnyParamsInvalid = !Object.keys(to.params)
    .filter((key) => key.endsWith('_id'))
    .map((key) => to.params[key])
    .every((param) => {
      return !isNaN(param) || isUUID(param);
    });
  if (areAnyParamsInvalid) {
    return next({ path: '/' });
  }

  next();
});

export default router;
